import {
  AttachMoney,
  PaidOutlined,
  Percent,
  ShoppingCartCheckout,
  TrendingUp,
} from "@mui/icons-material";
import { ApiMetric } from "@incendium/api";
import { ReactNode } from "react";
import { MetricOption } from "../types/metric";

export const PRIMARY_METRICS: MetricOption[] = [
  {
    id: ApiMetric.METRIC_REVENUE_PER_SESSION,
    label: "Revenue per session",
    description: "Total revenue generated divided by sessions.",
    recommended: true,
    icon: <AttachMoney fontSize="small" />,
  },
  {
    id: ApiMetric.METRIC_MACRO_CONVERSION_RATE_LAST,
    label: "Conversion rate",
    description: "% of sessions that convert.",
    icon: <Percent fontSize="small" />,
  },
  {
    id: ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
    label: "Effective session rate",
    description: "% of sessions that are high quality / engaged.",
    icon: <TrendingUp fontSize="small" />,
  },
  {
    id: ApiMetric.METRIC_AVERAGE_SALE_VALUE_LAST,
    label: "Average order value",
    description: "Average revenue per order.",
    icon: <ShoppingCartCheckout fontSize="small" />,
  },
  {
    id: ApiMetric.METRIC_REVENUE_LAST,
    label: "Total revenue",
    description: "Total revenue generated.",
    icon: <PaidOutlined fontSize="small" />,
  },
];

export const SUPPORTING_METRICS: MetricOption[] = [
  {
    id: ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
    label: "Effective session rate",
    description: "% of sessions that are high quality / engaged.",
    category: "Engagement",
    icon: <TrendingUp fontSize="small" />,
  },
  {
    id: ApiMetric.METRIC_SESSION_ADD_TO_CART_CLICK_RATE,
    label: "Add to cart rate",
    description: "% of sessions that add to cart.",
    category: "Conversion",
    icon: <ShoppingCartCheckout fontSize="small" />,
  },
  {
    id: ApiMetric.METRIC_CHECKOUT_COMPLETION_RATE,
    label: "Checkout completion rate",
    description: "% of sessions that reach purchase.",
    category: "Conversion",
    icon: <ShoppingCartCheckout fontSize="small" />,
  },
  {
    id: ApiMetric.METRIC_SESSIONS_COUNT,
    label: "Organic sessions",
    description: "Sessions from organic search.",
    category: "Acquisition",
    icon: <TrendingUp fontSize="small" />,
  },
  {
    id: ApiMetric.METRIC_AVERAGE_SALE_VALUE_LAST,
    label: "Average order value",
    description: "Average revenue per order.",
    category: "Revenue",
    icon: <AttachMoney fontSize="small" />,
  },
  {
    id: ApiMetric.METRIC_CART_ABANDONMENT_RATE,
    label: "Cart abandonment rate",
    description: "% of carts that do not convert to an order.",
    category: "Conversion",
    icon: <Percent fontSize="small" />,
  },
];

const ALL_METRICS = [...PRIMARY_METRICS, ...SUPPORTING_METRICS];

export const METRIC_LABEL_MAP: Partial<Record<ApiMetric, string>> =
  ALL_METRICS.reduce(
    (acc, metric) => {
      acc[metric.id] = metric.label;
      return acc;
    },
    {} as Partial<Record<ApiMetric, string>>,
  );

export const METRIC_ICON_MAP: Partial<Record<ApiMetric, ReactNode>> =
  ALL_METRICS.reduce(
    (acc, metric) => {
      acc[metric.id] = metric.icon;
      return acc;
    },
    {} as Partial<Record<ApiMetric, ReactNode>>,
  );
